import { DatabaseLayoutType } from '@databases/types/database/view';
import * as Parsimmon from 'parsimmon';

import { TokenType } from '../types';

export const LayoutLang = Parsimmon.createLanguage({
  /**
   * <Statement> -> table|gallery|<Board>
   *
   * "table" and "gallery" are terminals
   * @param r - language
   */
  Statement: function (r) {
    return Parsimmon.alt(
      Parsimmon.string('table').map(() => DatabaseLayoutType.TABLE),
      Parsimmon.string('gallery').map(() => DatabaseLayoutType.GALLERY),
      Parsimmon.string('calendar').map(() => DatabaseLayoutType.CALENDAR),
      r.Board
    ).map((result) => {
      if (
        result === DatabaseLayoutType.TABLE ||
        result === DatabaseLayoutType.GALLERY ||
        result === DatabaseLayoutType.CALENDAR
      ) {
        return {
          tokenType: TokenType.LAYOUT,
          type: result,
        };
      } else {
        return {
          tokenType: TokenType.LAYOUT,
          ...result,
        };
      }
    });
  },

  Board: function (r) {
    return Parsimmon.alt(r.BoardNew, r.BoardLegacy);
  },

  BoardNew: function (r) {
    return Parsimmon.seq(Parsimmon.string('board:'), r.FieldNameNew).map(
      ([_, fieldName]) => ({
        type: DatabaseLayoutType.BOARD,
        groupField: fieldName,
      })
    );
  },

  BoardLegacy: function (r) {
    return Parsimmon.seq(Parsimmon.string('board['), r.FieldNameLegacy)
      .skip(Parsimmon.all)
      .map(([_, fieldName]) => ({
        type: DatabaseLayoutType.BOARD,
        groupField: fieldName,
      }));
  },

  FieldNameNew: function () {
    return Parsimmon.all.map((s) => s.trim());
  },

  FieldNameLegacy: function () {
    const escapedChar = Parsimmon.string('\\')
      .then(Parsimmon.any)
      .map((c) => c);
    const normalChar = Parsimmon.noneOf("'");
    const content = Parsimmon.alt(escapedChar, normalChar);

    return Parsimmon.string("'")
      .then(content.many().map((chars) => chars.join('')))
      .skip(Parsimmon.string("'"));
  },

  _: function () {
    return Parsimmon.whitespace;
  },
});
